import * as React from 'react';
import H1 from '../../../../components/Layout/H1/H1';
import NoDataError from '../../../../components/Layout/NoDataError/NoDataError';
import AppMainCol from '../../../../components/Layout/PageGrid/AppMainCol';
import AppMainColBox from '../../../../components/Layout/PageGrid/AppMainColBox';
import AppSideCol from '../../../../components/Layout/PageGrid/AppSideCol';
import PageWrapper from '../../../../components/Layout/PageWrapper/PageWrapper';
import Row from '../../../Base/components/Grid/Row';
import { SlugType } from '../../../Base/types/SlugType'
import LeafletGridContainer from '../../containers/LeafletGrid/LeafletGridContainer';
import LeafletsAggregatedByStatesWidgetContainer
	from '../../containers/LeafletsAggregatedByStatesWidget/LeafletsAggregatedByStatesWidgetContainer';
import { ILeafletsAggregatedByStateType } from '../../types/ILeafletsAggregatedByStateType';
import AdItem from '../../../../components/General/AdItem/AdItem';


interface ILeafletsByVendorInStateProps {
	vendorSlug: SlugType;
	stateSlug: SlugType;
}

class LeafletsByVendorInState extends React.Component<ILeafletsByVendorInStateProps & IWithRouteMetadataType, {}> {
	public static defaultProps = {};

	public render() {
		const { routeMetadata, vendorSlug, stateSlug } = this.props;

		const vendorName = (routeMetadata && routeMetadata.vendor && routeMetadata.vendor.title) ? routeMetadata.vendor.title : vendorSlug;
		const stateName = (routeMetadata && routeMetadata.state && routeMetadata.state.title) ? routeMetadata.state.title : stateSlug;

		return (
			<PageWrapper breadcrumbs={this.getBreadcrumbs()}>

				<AdItem
					desktopAdId={4403489}
					maxHeight={250}
					type="billboard"
				/>
				
				<H1>
					{routeMetadata.pageTitle}
				</H1>

				<Row>
					<AppMainCol
						boxed={true}
						onTop={true}
					>
						<AppMainColBox nested={true} boxed={true}>

							<LeafletGridContainer
								orderBy="rank"
								orderDir="desc"
								enablePagination={true}
								vendorSlug={vendorSlug}
								stateSlug={stateSlug}
								onlyNearbyLeaflets={false}
								gridKey={routeMetadata.queryKey}
								pushRouteMetadata={true}
								contentBreaks={{
									6: (
										<AdItem
											mobileAdId={4403478}
											maxHeight={250}
											type="content"
											title="Mobile Rectangle 1"
										/>
									),
	
									12: (
										<AdItem
											mobileAdId={4403477}
											maxHeight={250}
											type="content"
											title="Mobile Rectangle 2"
										/>
									)
								}}
							>
								<NoDataError />
							</LeafletGridContainer>

						</AppMainColBox>
					</AppMainCol>

					<AppSideCol boxed={true} onTop={true}>
						<div>
							<LeafletsAggregatedByStatesWidgetContainer
								widgetKey={`lvst-${vendorSlug}-${stateSlug}-state-widget`}
								limit={10}
								title={`${vendorName} Prospekte in anderen Bundesländern`}
								routeCallbk={this.routerCallbkStateListWidget}
								excludeSlug={stateSlug}
								vendorSlug={vendorSlug}
							/>

							<AdItem
								desktopAdId={4403488}
								maxHeight={250}
								maxWidth={300}
								type="content"
								title="Medium Rectangle 1"
							/>
						</div>
					</AppSideCol>
				</Row>

			</PageWrapper>
		);
	}

	/**
	 * Returns the breadcrumb path for this page
	 */
	private getBreadcrumbs() {

		return [
			{
				label: 'Prospekte',
				route: 'LeafletListingRoute'
			} as IBreadcrumbItemType,
			{
				label: this.props.routeMetadata ? this.props.routeMetadata.vendor.title: '',
				route: 'VendorDetailRoute',
				routeParams: {vendor: this.props.vendorSlug}
			} as IBreadcrumbItemType,
			{
				label: this.props.routeMetadata ? this.props.routeMetadata.state.title: '',
			} as IBreadcrumbItemType,

		];
	}

	/**
	 * Defines the route the vendor list widget should be routed towards
	 */
	private routerCallbkStateListWidget = (item: ILeafletsAggregatedByStateType) => {
		const { vendorSlug } = this.props;

		return {
			name: 'LeafletsByVendorInStateRoute',
			params: {
				vendor: vendorSlug,
				state: item.group.slug,
			},
		};
	};
}

export default LeafletsByVendorInState;
